import { generateSignature } from "../utils/security";

const baseUrl =
  process.env.REACT_APP_BACKEND_URL ||
  "https://asia-south1-ganesh-holiday-homes.cloudfunctions.net";

const cleanBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;

const DEFAULT_PAYMENT_URL =
  process.env.REACT_APP_PAYMENT_SERVICE_URL ||
  new URL("paymentService", cleanBase).toString();

/**
 * Initiates a PayU payment request with the Payment Microservice
 */
export async function initiatePayUCheckout(payload) {
  const apiSecret =
    process.env.REACT_APP_PLATFORM_API_SECRET ||
    process.env.REACT_APP_API_SECRET;
  const action = "initiatePayment";
  const wrappedPayload = { action, ...payload };

  const { signature, timestamp } = generateSignature(
    wrappedPayload,
    action,
    apiSecret
  );

  const headers = {
    "Content-Type": "application/json",
    "x-api-key": signature,
    "x-timestamp": timestamp,
  };

  const paymentBase = DEFAULT_PAYMENT_URL.endsWith("/")
    ? DEFAULT_PAYMENT_URL
    : `${DEFAULT_PAYMENT_URL}/`;
  const endpoint = new URL("payments/initiate", paymentBase).toString();

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers,
      body: JSON.stringify(wrappedPayload),
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || !result.success) {
      const errorMsg =
        result?.error?.message || result?.message || `HTTP ${response.status}`;
      const err = new Error(errorMsg);
      if (response.status >= 500 || response.status === 404) {
        err.isServiceDown = true;
      }
      throw err;
    }

    return result.data;
  } catch (err) {
    console.error("❌ PayU Initiation Error:", err);
    if (err.name === "TypeError" || !navigator.onLine) {
      err.isServiceDown = true;
    }
    throw err;
  }
}
/**
 * Automatically builds a hidden HTML form and submits it to redirect the user to PayU Hosted Checkout
 */
export function submitPayUForm(payuData) {
  if (!payuData || (!payuData.actionUrl && !payuData.params?.actionUrl)) {
    throw new Error("Invalid PayU response: Missing actionUrl");
  }

  const actionUrl = payuData.actionUrl || payuData.params?.actionUrl;
  const form = document.createElement("form");
  form.method = "POST";
  form.action = actionUrl;
  form.style.display = "none";

  const fields = [
    "key",
    "txnid",
    "amount",
    "productinfo",
    "firstname",
    "email",
    "phone",
    "surl",
    "furl",
    "hash",
    "udf1",
    "udf2",
    "udf3",
    "udf4",
    "udf5",
  ];

  const paramsSource = payuData.params || payuData;

  fields.forEach((fieldName) => {
    const val =
      paramsSource[fieldName] !== undefined && paramsSource[fieldName] !== null
        ? paramsSource[fieldName]
        : payuData[fieldName];
    if (val !== undefined && val !== null && String(val).trim() !== "") {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = fieldName;
      input.value = String(val);
      form.appendChild(input);
    }
  });

  document.body.appendChild(form);
  form.submit();
}
